import { useEffect } from "react";
import AdditionalChargeByDate from "../../AdditionalChargeByDate";
import PriceEstimate from "../../PriceEstimate";

const Step2 = ({ formik, data, priceCalculate, t }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      <div className="aditional_and_prices">
        <AdditionalChargeByDate formik={formik} data={data} />
        <div className="mt-8">
          <PriceEstimate priceCalculate={priceCalculate} type={data?.type} />
        </div>
      </div>
    </div>
  );
};

export default Step2;
